import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import MainMenu from './MainMenu';
import ActionIcons from './ActionIcons';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white text-black shadow-md w-full z-50">
      <div className="container mx-auto px-4 flex justify-between items-center h-16">
        <Logo />
        <div className="hidden md:flex items-center space-x-8">
          <MainMenu isMobile={false} />
        </div>
        <div className="flex items-center space-x-4">
          <ActionIcons />
          <button 
            className="md:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-white py-4 px-6 flex flex-col space-y-4 w-full shadow-inner border-t border-gray-100 max-h-[80vh] overflow-y-auto">
          <MainMenu isMobile={true} onClose={() => setMenuOpen(false)} />
        </div>
      )}
    </nav>
  );
};

export default Navbar;